import { useState } from 'react';
import PropTypes from 'prop-types';

import Image from '../image/Image';

import { ReactComponent as ArrowIcon } from '../../../resources/icons/arrow-single.svg';

import './image-carousel.scss';

const ImageCarousel = ({ images, startIndex, setStartIndex }) => {
  const [currentImage, setCurrentImage] = useState(startIndex);

  const handlePreviousClick = (event) => {
    event.stopPropagation();
    if (currentImage === 0) {
      setCurrentImage(images.length - 1);
    } else {
      setCurrentImage(currentImage - 1);
    }
  };

  const handleNextClick = (event) => {
    event.stopPropagation();
    if (currentImage === images.length - 1) {
      setCurrentImage(0);
    } else {
      setCurrentImage(currentImage + 1);
    }
  };

  const image = images[currentImage];

  return (
    <div className="image-carousel" onClick={() => setStartIndex(undefined)}>
      {images.length > 1 && (
        <div
          className="image-carousel__action"
          onClick={handlePreviousClick}
          data-testid="image-carousel-previous-button"
        >
          <ArrowIcon />
        </div>
      )}
      <div className="image-carousel__image-container" onClick={(event) => event.stopPropagation()}>
        {image instanceof String || typeof image === 'string' ? (
          <Image externalReference={image} alt="" />
        ) : (
          <Image file={image} alt="" />
        )}
      </div>
      {images.length > 1 && (
        <div className="image-carousel__action" onClick={handleNextClick}>
          <ArrowIcon />
        </div>
      )}
    </div>
  );
};

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])),
  startIndex: PropTypes.number.isRequired,
  setStartIndex: PropTypes.func.isRequired,
};

ImageCarousel.defaultProps = {
  images: [],
};

export default ImageCarousel;
